import { render } from "./FlatsList.vue?vue&type=template&id=71527935"
import script from "./FlatsList.vue?vue&type=script&lang=js"
export * from "./FlatsList.vue?vue&type=script&lang=js"

import "./FlatsList.vue?vue&type=style&index=0&id=71527935&lang=less"

import exportComponent from "D:\\panorama-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__